import request from '@/config/axios'

export type WordSeries = {
  id: number
  coverUrl: string
  name: string
  author: string
}
export type Word = {
  id: number
  seriesId?: number
  chinese: string
  english: string
  coverUrl: string
  audioUrl: string
}

export const getWordSeriesPage = (params: any) => {
  return request.get({
    url: '/word-series/page',
    params
  })
}

export const getWordList = (seriesId: any) => {
  return request.get({
    url: '/word/list?seriesId=' + seriesId
  })
}

export const getVideoEpisodesList = (seriesId: any, seasonId: number) => {
  return request.get({
    url: '/video-episodes/list?seriesId=' + seriesId + '&seasonId=' + seasonId
  })
}

export const getWordsList = (seriesId: number) => {
  return request.get({
    url: '/words/list?seriesId=' + seriesId
  })
}